export enum AlertType {
  CONTACT_US_ALERT = "contactUsAlert", // When the customer can get the insurance through an advisor
  STOPPER_ALERT = "stopperAlert", // When the customer cannot get the insurance
  INPUT_ERROR_ALERT = "inputErrorAlert", // When the customer encounters input errors
  SYSTEM_ERROR_ALERT = "systemErrorAlert", // When the customer encounters system errors
}

export enum AlertVariant {
  BORDER_ONLY,
  BORDER_WITH_BACKGROUND,
}
